import { ForestProductPriceUpdateList } from '../../../../components/ForestProduct/ForestProductPriceUpdates/ForestProductPriceUpdateList';

export function ForestProductPriceUpdates() {
  return <ForestProductPriceUpdateList />;
}
